import React, { Component } from 'react';
import { connect } from 'react-redux'
import "datatables.net-bs4/css/dataTables.bootstrap4.css"
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
import Modal from '../../../../basic-component/Modal';
import AddTeacher from './AddTeacher';
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
const $ = require('jquery');
require('jszip');
require('pdfmake');
$.DataTable = require('datatables.net-bs4');
// require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-keytable-bs4');
require('datatables.net-responsive-bs4');
// require('datatables.net-searchpanes-bs4');

class Teacher extends Component {

    setTableData() {
        let teacherData = this.props.teacherData.map((row) => {
            row['action'] = "<button class='btn btn-info btn-sm'><i class='fa fa-edit'></i></button>&nbsp;<button class='btn btn-danger btn-sm'><i class='fa fa-trash-o'></i></button>";
            return row
        });
        this.$el = $(this.el);
        var table = this.$el.DataTable({
            // lengthChange: false,
            dom: 'lBfrtip',
            data: teacherData,
            columns: [
                { data: 'name' },
                { data: 'classes' },
                { data: 'email' },
                { data: 'address' },
                { data: 'Phone' },
                { data: 'action' },
            ],
            destroy: true,
            buttons: [
                // {
                //     extend: 'pdf',
                //     text: 'PDF',
                //     className: 'btn btn-success'
                // },
                {
                    extend: 'csv',
                    text: 'CSV',
                    title: "Students Records",
                    className: 'btn btn-success btn-sm'
                },
                {
                    extend: 'print',
                    text: 'Print',
                    title: "<h1 class='text-center'>Student Record</h1>",
                    className: 'btn btn-success btn-sm'
                }
            ]
        });
        table.buttons().container().appendTo(".export-buttons ");
        // $('#myTable tbody').on('dblclick', 'tr', function () {
        //     var data = table.row(this).data();
        //     console.log(data);
        //     alert('You clicked on ' + data.name + '\'s row');
        // });
    }
    componentDidMount() {
        this.setTableData();

    }
    shouldComponentUpdate(nextProps, nextState) {

        this.setTableData()
        //not updating anything

        return true
    }

    render() {
        const newTeacher = {
            name: "kumar",
            classes: "Std 2",
            email: "xyz@gmail.com",
            address: "Ramghar",
            Phone: "7894561235"
        }

        let teachers = (<div>
            {/* <h2 className="text-secondary" style={{ paddingLeft: "0.5rem", paddingTop: "1rem" }}>Student</h2> */}
            <div className="card card-design-2">
                <div className="card-header bg-primary text-white">
                    Teacher List by Classes
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-4 col-sm-12">
                            <div className="row">
                                <div className="mr-1 pd-1"> Select Class</div>
                                <select className="form-control"><option>Std 1</option></select>
                            </div>
                        </div>
                        <div className="col-lg-8 col-sm-12 text-right export-buttons">
                            <button className="btn btn-primary btn-sm" data-toggle="modal" data-target="#addTeacherModal" ><i className="fa fa-plus"></i> Add Teacher</button>&nbsp;
                            <button className="btn btn-info btn-sm" onClick={() => this.props.addTeacherToStore(newTeacher)}> Add Teacher</button>
                            {/* <div className="export-buttons"></div> */}
                        </div>
                    </div>
                    <div className="row">
                        <div className=" table-responsive" style={{ padding: "10px" }}>
                            <table id="myTable" className="table table-hover table-bordered dt-responsive nowrap" width="100%" ref={el => this.el = el} >
                                <thead>
                                    <tr>
                                        <th>Full Name</th>
                                        <th>Class</th>
                                        <th>Email</th>
                                        <th>Address</th>
                                        <th>Phone</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
        return (
            <div>

                <Modal header="Add Teacher" modalWidth="modal-xl" modalId="addTeacherModal"><AddTeacher /></Modal>
                {teachers}

            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        isUserLoggedIn: state.isAuthenticated,
        teacherData: state.teacherData
    };
}
const mapDispatchToProps = dispatch => {
    return {
        addTeacherToStore: (newTeacher) => dispatch({ type: 'AddTeacher', teacherData: newTeacher }),
        deleteTeacherToStore: (roll) => dispatch({ type: "DeleteStudent", roll: roll })
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Teacher);